import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  Inject,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { SourcesMaterialsApi } from '@core/api/materials/api';

import { DocumentComponent } from '../file-preview-modal/drivers/document/document.component';

@Component({
    selector: 'app-preview-modal',
    templateUrl: './preview-modal.component.html',
    styleUrls: ['./preview-modal.component.scss'],
    standalone: true,
    imports: [MatButton]
})
export class PreviewModalComponent implements AfterViewInit {
  @ViewChild('dynamicContainer', { read: ViewContainerRef }) container:
    | ViewContainerRef
    | undefined;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { filename: string },
    private dialogRef: MatDialogRef<PreviewModalComponent>,
    private cdr: ChangeDetectorRef
  ) {}

  ngAfterViewInit() {
    this.createComponent();
  }

  createComponent() {
    const componentRef = this.container?.createComponent(DocumentComponent);
    if (componentRef) {
      componentRef.instance.fileLink = this.getLink(this.data.filename!);
      this.cdr.detectChanges();
    }
  }

  cancel() {
    this.dialogRef.close();
  }

  protected getLink(fileName: string) {
    return SourcesMaterialsApi.downloadFile(fileName).url;
  }
}
